export default { 'FormattedPayoutsRow.view': { en: 'View', fr: 'Voir' } };
